import React, { Component } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import MainMenu from './MainMenu';

export default class Service1101 extends Component {
  render() {
    return (
      <div className="service-1101">
        <Switch>
          <Route
            path="/main_menu/mydashboard/:popup?"
            render={(routeProps) => <MainMenu {...routeProps} currentCategory="0" />}
          />
          <Route
            path="/main_menu/stay/:popup?"
            render={(routeProps) => <MainMenu {...routeProps} currentCategory="-1" />}
          />
          <Route
            path="/main_menu/education/:popup?"
            render={(routeProps) => <MainMenu {...routeProps} currentCategory="-2" />}
          />
          <Route
            path="/main_menu/entertainment/:popup?"
            render={(routeProps) => <MainMenu {...routeProps} currentCategory="-3" />}
          />
          <Route
            path="/main_menu/:catName/:popup?"
            render={({ match }) => <Redirect to={`/main_menu/${match.params.catName}/${match.params.popup}`} />}
          />
          <Route path="/main_menu" render={(routeProps) => <MainMenu {...routeProps} currentCategory="1" />} />
        </Switch>
      </div>
    );
  }
}
